import { configureStore, combineReducers } from '@reduxjs/toolkit'

import appApi from 'api'
import auth from 'slices/auth'
import profile from 'slices/profile'
import notificationPanel from 'slices/NotificiationPanel'
import billpayment from 'slices/Billpayments'
import onboardingStep from 'slices/OnboardingStep'
import bulkPayments from 'slices/bulk/BulkPayments'
import processedBulkRecords from 'slices/bulk/ProcessedRecords'
import loanFlow from 'slices/loanFlowSlice'
import cardFlow from 'slices/cardFlowSlice'

import { loadState, saveState } from './utils/storage'

const rootReducer = combineReducers({
  authReducer: auth,
  profileReducer: profile,
  notificationPanel,
  billpayment,
  onboardingStep,
  bulkPayments,
  processedBulkRecords,
  loanFlowReducer: loanFlow,
  cardFlowReducer: cardFlow,
  [appApi.reducerPath]: appApi.reducer,
})

const persistedState = loadState()

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(appApi.middleware),
  preloadedState: persistedState,
})

let saveTimeout: ReturnType<typeof setTimeout> | null = null
store.subscribe(() => {
  if (saveTimeout) clearTimeout(saveTimeout)
  saveTimeout = setTimeout(() => {
    const state = store.getState()
    saveState({
      loanFlowReducer: state.loanFlowReducer,
      cardFlowReducer: state.cardFlowReducer,
    })
  }, 200)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
